import { Vector3 } from '@anov/3d-core'

import { getPosition } from 'suncalc'

// import * as suncalc from 'suncalc'

// // @ts-ignore   handle build
// const getPosition = suncalc.default.getPosition

/**
 * get three position
 * @param date
 * @param latitude
 * @param longitude
 * @param distance
 * @returns
 */
export const getThreePosition = (date: Date, latitude: number, longitude: number, distance: number) => {
  const { altitude, azimuth } = getPosition(date, latitude, longitude)

  const x = distance * (Math.cos(altitude)) * (Math.cos(azimuth))
  const z = distance * (Math.cos(altitude)) * (Math.sin(azimuth))
  const y = distance * (Math.sin(altitude))

  return new Vector3(x, y, z)
}

/**
 * get sun position
 * @param date
 * @param latitude
 * @param longitude
 * @returns
 */
export const getSunPosition = (date: Date, latitude: number, longitude: number) => {
  const { altitude, azimuth } = getPosition(date, latitude, longitude)

  return {
    altitude,
    azimuth,
  }
}

/**
 * handle time string eg:18:00 => date type now
 * @param time
 * @returns
 */
export const handleTimeString = (time: string) => {
  const today = new Date()
  const [hours, minutes] = time.split(':').map(Number)
  today.setHours(hours, minutes, 0, 0)

  return today
}